/**
 * Single source of truth for the AnimalMela mark.
 * All logo instances across the app should use <BrandLogo size="…" /> so sizing
 * stays consistent. Aspect ratio is 1:1 — never stretched, uses object-cover.
 *
 * Sizes match the spec: header, hero, login, sidebar, slip, gatepass, receipt.
 */
import { LOGO_URL } from "@/constants/brand";

const SIZES = {
  // Desktop header — 48px
  desktopHeader: { h: 48, radius: "1rem" },
  // Mobile header — 40px
  mobileHeader: { h: 40, radius: "0.875rem" },
  // Login screen — 72px, centered
  login: { h: 72, radius: "1.25rem" },
  // Sidebar expanded — 36px
  sidebarExpanded: { h: 36, radius: "0.75rem" },
  // Sidebar collapsed — 28px
  sidebarCollapsed: { h: 28, radius: "0.625rem" },
  // Registration slip / Receipt inside PDF — 32px receipt, 36px receipt-pdf, 40px gate pass
  slip: { h: 32, radius: "0.625rem" },
  receipt: { h: 36, radius: "0.625rem" },
  gatePass: { h: 40, radius: "0.75rem" },
  // Landing hero — 64px (large brand mark)
  hero: { h: 64, radius: "1rem" },
  // Footer / inline small
  footer: { h: 32, radius: "0.5rem" },
};

export default function BrandLogo({
  size = "desktopHeader",
  mobileSize,
  alt = "AnimalMela",
  className = "",
  ring = true,
  bg = false,
  ...rest
}) {
  const spec = SIZES[size] || SIZES.desktopHeader;
  const mobileSpec = mobileSize ? (SIZES[mobileSize] || spec) : spec;
  const dim = spec.h;
  const mDim = mobileSpec.h;
  const responsive = mobileSize && mDim !== dim;
  return (
    <img
      src={LOGO_URL}
      alt={alt}
      width={dim}
      height={dim}
      loading="eager"
      decoding="async"
      draggable={false}
      crossOrigin="anonymous"
      style={responsive
        ? { objectFit: "cover", flexShrink: 0,
            "--am-brand-h": `${dim}px`, "--am-brand-mh": `${mDim}px`,
            "--am-brand-r": spec.radius, "--am-brand-mr": mobileSpec.radius }
        : { height: `${dim}px`, width: `${dim}px`, borderRadius: spec.radius,
            objectFit: "cover", flexShrink: 0 }}
      className={`${responsive ? "am-brand-responsive" : ""} ${ring ? "ring-1 ring-border" : ""} ${bg ? "bg-white" : ""} ${className}`.trim()}
      {...rest}
    />
  );
}
